import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import GlobalStyle from './styles/global';
import AppProvider from './hooks';
import RoutesComponent from './routes';

const App: React.FC = () => {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <AppProvider>
        <RoutesComponent />
      </AppProvider>
      <GlobalStyle />
    </BrowserRouter>
  );
};

export default App;
